module.exports = __webpack_public_path__ + "static/media/GettyImages_870316052.0.aad29a43.jpg";